import { render, staticRenderFns } from "./BindVoucher.vue?vue&type=template&id=338f5974&scoped=true"
import script from "./BindVoucher.vue?vue&type=script&lang=js"
export * from "./BindVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f5974",
  null
  
)

export default component.exports